//consultas modulo credito-estimaciones

import { gql } from "graphql-tag";

const getEvaluaciones = gql`
  query periodos {
    creditos_periodosCargados
  }
`;

const getPeriodosAT = gql`
 query Query($idPlantilla: Int) {
    evaluaciones(idPlantilla: $idPlantilla) {
      id
      fechaContable
      idPlantilla
      idInstitucion
    }
  }
`;
const getData = gql`
  query Query($periodo: String!) {
  tabla_Amortizacion_sub_calculos(periodo: $periodo) {
    creditos {
      CN1
      CN2
      CN3
      CN4
      CN5
      CN6
      CN7
      CN8
    }
    saldos {
      CS1
      CS2
      CS3
      CS4
      CS5
      CS6
      CS7
      CS8
    }
    deducciones_autorizadas {
      CD1
      CD2
      CD3
      CD4
      CD5
      CD6
      CD7
      CD8
    }
    monto_constituido {
      CM1
      CM2
      CM3
      CM4
      CM5
      CM6
      CM7
      CM8
    }
    caucion {
      CC1
      CC2
      CC3
      CC4
      CC5
      CC6
      CC7
      CC8
    }
    garantia_liquida {
      GL1
      GL2
      GL3
      GL4
      GL5
      GL6
      GL7
      GL8
    }
  }
}
`;

const getDetalleVarTemp = gql`
  query Query($idEvaluacion: Int!, $idVarTemp: String!) {
    detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion, idVarTemp: $idVarTemp) {
      idEvaluacion
      idVarTemp
      valor
    }
  }
`;



export {getEvaluaciones, getData, getPeriodosAT, getDetalleVarTemp }